import useTopics from '~hooks/useTopics';
import { useNewsfeed } from '~services/api/hooks/newsfeed.hooks';
import { Header } from './feed/Header';
import { Item } from './feed/Item';
import { Link } from './feed/Link';
import { List } from './feed/List';
import { Teaser } from './feed/Teaser';

export function Feed({ title }: { title: string }) {
  const { getTopicById } = useTopics();
  const { newsList, preferences } = useNewsfeed();
  const shouldShowTeaser = preferences.topics.length === 0 || newsList.length === 0;

  return (
    <div className="front--feed feed py-4">
      <div className="container mx-auto my-4">
        <Header title={title} />
        {shouldShowTeaser && <Teaser />}
        <List>
          {newsList.map(news => (
            <Item
              key={news.id}
              title={news.title}
              description={news.description}
              LinkComponent={Link}
              href={news.pageAlias}
              imageSrc={news.imageSrc}
              imageCrops={news.crops}
              topics={news.topicIds?.map(topicId => getTopicById(topicId)).filter(Boolean)}
            />
          ))}
        </List>
      </div>
    </div>
  );
}
